import React from 'react';
import { Divider } from '@mui/material';


const DeleteAccountPopUp = ({isClickedToDelete, setIsClickedToDelete, DeleteAccount}) => {
  return (
    <div
      className={`delete-user-popup ${
        isClickedToDelete && "show-delete-user-popup"
      }`}
    >
      <div className="delete-pop-up-box">
        <h4>Are you really want to delete your account?</h4>
        <Divider />
        <div className="btn-confirm-delete-box">
          <button onClick={() => setIsClickedToDelete(false)}>Cancel</button>
          <button onClick={DeleteAccount}>
            Delete
          </button>
        </div>
      </div>
    </div>
  )
}

export default DeleteAccountPopUp